export const SET = 'SurveyResponse/SET';
export const SET_QUESTION_RESPONSE = 'SurveyResponse/SET_QUESTION_RESPONSE';
export const UPDATE_DETAILS_QUESTION_RESPONSE = 'SurveyResponse/UPDATE_DETAILS_QUESTION_RESPONSE';
export const UNSET_QUESTION_RESPONSE = 'SurveyResponse/UNSET_QUESTION_RESPONSE';